import FundReportService from "_fil_local_addon/camc-fund-report-list/fund_report_service";

class AMCMessageUtil {
    static displayMessage($wrapperElement, message = "暂无数据显示") {
        if ($wrapperElement && $wrapperElement.length > 0) {
            $wrapperElement.empty();
            $wrapperElement.show();
            $wrapperElement.append(`<div class="api-messaging-level">${message}</div>`);
        }
    }
}

class AMCFundStatusUtil {
    static isActive = null;
    static activeFundPromise = null;
    static lastFundCode = null; // Track the last used fund code
    static fetchCompleted = false;

    static async isActiveFund() {
        // Check if fundCode has changed
        if (this.lastFundCode !== window.fundCode) {
            this.resetCache();
        }

        // Return cached promise if a request is already in progress
        if (this.activeFundPromise) {
            return this.activeFundPromise;
        }

        // Create a new promise if none exists
        this.lastFundCode = window.fundCode; // Update the last used fund code

        this.activeFundPromise = new Promise(async (resolve) => {
            try {
                const result = await FundReportService.getFundReport(window.fundCode);
                this.isActive = this.evaluateFundReports(result);
            } catch (error) {
                console.error("Error fetching fund reports:", error);
                this.isActive = false;
            }
            this.fetchCompleted = true;
            resolve(this.isActive);
        });

        return this.activeFundPromise;
    }

    static resetCache() {
        this.isActive = null;
        this.activeFundPromise = null;
        this.fetchCompleted = false;
    }

    static evaluateFundReports(reports) {
        if (reports && reports.length) {
            return reports.some((item) => item["establishment_doc"] === "true");
        }
        return false;
    }

    static async getFundStatus() {
        // If we don't have a value yet and there's a fundCode, wait for the fetch to complete
        if (!this.fetchCompleted && window.fundCode) {
            await this.isActiveFund();
        }
        return this.isActive;
    }
}

class UrlTool {
    static getParamFromUrl(key) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const result = urlParams.get(key);
        return result;
    }

    static addPath(url = "", path = "") {
        let result = "";
        if (url || path) {
            url = url.endsWith("/") ? url : url + "/";
            path = path.startsWith("/") ? path.slice(1) : path;
            result = url + path;
            result = result.replace(/\/$/, "");
        }
        return result;
    }

    static addParam(url = "", paramKey = "", paramValue = "") {
        if (url && paramKey) {
            if (url.indexOf("?") >= 0) {
                url = url + "&" + paramKey + "=" + paramValue;
            } else {
                url = url + "?" + paramKey + "=" + paramValue;
            }
        }
        return url;
    }
}

export { AMCMessageUtil, AMCFundStatusUtil, UrlTool };
